import { plainToInstance, Transform, Type } from 'class-transformer'

import { ChannelInfo, ErrorChannelInfo, SuccessChannelInfo } from './CheckChannels'

export class ChannelInfoResponse {
  @Transform(({ value }) => {
    return value.map((info: ChannelInfo) => {
      if (info.status) {
        return plainToInstance(SuccessChannelInfo, info)
      } else {
        return plainToInstance(ErrorChannelInfo, info)
      }
    })
  })
  data!: Array<ChannelInfo>
}
